import React from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Avatar } from '@mui/material';
import { sucursales } from '../data';

function Stores() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Sucursales</Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Logo</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Colores</TableCell>
              <TableCell>Dirección</TableCell>
              <TableCell>Teléfono</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sucursales.map(s => (
              <TableRow key={s._id} hover>
                <TableCell>
                  <Avatar variant="rounded" sx={{ bgcolor: s.color_primario, width: 40, height: 40 }}>
                    {s.nombre.charAt(0)}
                  </Avatar>
                </TableCell>
                <TableCell fontWeight={600}>{s.nombre}</TableCell>
                <TableCell><Chip label={s.codigo} size="small" variant="outlined" /></TableCell>
                <TableCell>
                  <Box display="flex" gap={1}>
                    <Box sx={{ width: 20, height: 20, bgcolor: s.color_primario, borderRadius: '50%', border: '2px solid #ddd' }} />
                    <Box sx={{ width: 20, height: 20, bgcolor: s.color_secundario, borderRadius: '50%', border: '2px solid #ddd' }} />
                  </Box>
                </TableCell>
                <TableCell>{s.direccion}</TableCell>
                <TableCell>{s.telefono}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Stores;
